export default "__VITE_ASSET__D3irz8F5__"